export default "__VITE_ASSET__BdB6M9Ij__"